module.exports = __webpack_public_path__ + "static/img/2.0c0d5a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/14/2.png
// module id = Tuzl
// module chunks = 2